import React, { useState, useEffect, useRef } from 'react';
import '../style/HamburgerMenu.css';
import { useCart } from '../contexts/CartContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../contexts/AuthContext';
import { useCartMenu } from '../contexts/CartMenuContext';
import { useHamburgerMenu } from '../contexts/HamburgerMenuContext';
import { useTranslation } from 'react-i18next';
import { languageOptions, getSelectedLanguageOption } from '../i18n';
import { useCurrency} from '../contexts/CurrencyContext';
import { shouldShowCurrencySelector } from '../utils/currencySelector';

const RightMenu = () => {
    const { t, i18n } = useTranslation();
    const { cartItems, removeFromCart, increaseItemQuantity, decreaseItemQuantity } = useCart();
    const { isCartOpen, setIsCartOpen } = useCartMenu();
    const { isHamburgerOpen, setIsHamburgerOpen } = useHamburgerMenu();
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    
    const selectedLanguageOption = getSelectedLanguageOption(i18n.language);

    const handleLanguageSelectChange = (selectedOption) => {
    if (selectedOption) {
    i18n.changeLanguage(selectedOption.value);
    }
    };

    const cartMenuRef = useRef(null);
    const hamburgerMenuRef = useRef(null);

    // Close menus when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                (isCartOpen && cartMenuRef.current && !cartMenuRef.current.contains(event.target)) ||
                (isHamburgerOpen && hamburgerMenuRef.current && !hamburgerMenuRef.current.contains(event.target))
            ) {
                setIsCartOpen(false);
                setIsHamburgerOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isCartOpen, isHamburgerOpen, setIsCartOpen, setIsHamburgerOpen]);

    const closeMenu = () => {
        setIsCartOpen(false);
        setIsHamburgerOpen(false);
    };

    const handleCheckout = () => {
        closeMenu();
        navigate('/checkout');
    };

    const { selectedCurrency, currencySymbol, currencyOptions, formatPrice, calculateConvertedTotalPrice, handleCurrencyChange } = useCurrency();
    const selectedCurrencyOption = currencyOptions.find(opt => opt.value === selectedCurrency.toLowerCase());
    const showCurrencySelector = shouldShowCurrencySelector(location.pathname);

    return (
        <div>
            <div>
                <nav className={`menu menu-cart-min-width ${isCartOpen ? 'show' : ''}`} ref={cartMenuRef}>
                    <div className="menu-header">
                        <FontAwesomeIcon
                            className="account-section-icon close-button"
                            icon={faX}
                            onClick={closeMenu}
                        />
                    </div>
                    <div className="menu-content">
                        {cartItems.length > 0 ? (
                            <div>
                                <div  className="cart-items-container">
                                    {cartItems.map((item, index) => (
                                        <div>
                                            <li key={index} className="order-item-hover">
                                                <div className="order-item order-item-right-bar">
                                                    <img className="cart-image-preview cart-image-phone" src={item.previewUrl} alt={item.name} />
                                                    <div className="order-item-details order-item-details-menu">
                                                        <p className="order-item-name order-item-name-menu"><strong>{item.name}</strong></p>
                                                        <div className="order-details order-details-small order-details-small-menu order-details-phone">
                                                             {item.selectedSize?.description && item.selectedSize?.description !== "N/A" && (
                                                                <p>{t("checkout.sizeLabel")}: {t("options.size" + item.selectedSize?.description) || "N/A"}</p>
                                                             )}
                                                            {item.selectedFirmness && item.selectedFirmness !== "N/A" && (
                                                                <p>
                                                                     | {t("checkout.softnessLabel")}: {typeof item.selectedFirmness?.description === "string"
                                                                    ? t("options.firmness" + item.selectedFirmness.description).replace(/Firmness|Souplesse/gi, "").trim()
                                                                    : t("options.firmness" + item.selectedFirmness) || "N/A"}
                                                                </p>
                                                            )}
                                                             {item.selectedColor?.description && item.selectedColor?.description !== "N/A" && (
                                                                <p> | {t("checkout.colorLabel")}: {item.selectedColor?.description || "N/A"}</p>
                                                             )}
                                                             {item.selectedOption?.description && item.selectedOption?.description !== "N/A" && (
                                                                <p> | {t("checkout.optionsLabel")}: {t("options.option" + item.selectedOption?.description)}</p>
                                                             )}
                                                        </div>
                                                        <div className="horitontal-content">
                                                            <FontAwesomeIcon 
                                                                className="close-button smaller-button-icon"
                                                                icon={faTrashCan}
                                                                onClick={() => removeFromCart(item.id)}
                                                            />
                                                            <div className="bouton-add">
                                                                <button id="minus" onClick={() => decreaseItemQuantity(item.id)}>−</button>
                                                                <input type="number" value={item.numberOfItems} id="input"/>
                                                                <button id="plus" onClick={() => increaseItemQuantity(item.id)}>+</button>
                                                            </div>                                     
                                                        </div>
                                                        <div className="horitontal-prices">
                                                            <div className="order-details order-details-small order-details-small-menu order-details-phone ">
                                                                <p>({currencySymbol}{formatPrice(calculateConvertedTotalPrice(item.prcbdn))} each)</p>
                                                            </div>
                                                            <p className="order-item-name order-item-name-menu"><strong>{currencySymbol}{formatPrice(calculateConvertedTotalPrice(item.prcbdn) * item.numberOfItems)}</strong></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <div class="left-horizontal-container smaller-even right-menu-smaller">
                                                <div class="small-horizontal"></div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div class="button-checkout-container">
                                    <div className="subtotal-text">
                                        <p className="order-item-name order-item-name-menu">{t("checkout.subtotalLabel")}: {currencySymbol}{formatPrice(cartItems.reduce((acc, item) => acc + calculateConvertedTotalPrice(item.prcbdn) * item.numberOfItems, 0))}</p>
                                    </div>
                                    <button className="form-button checkout-button" onClick={handleCheckout}>{t("checkout.checkoutLabel")}</button>
                                </div>
                            </div>
                        ) : (
                            <div className="no-items-text-container">
                                <p className="no-items-text">{t("checkout.emptyCartLabel")}</p>
                            </div>
                        )}
                    </div>
                </nav>
            </div>

            <div>
                {isHamburgerOpen && <div className="dim-overlay"></div>}
        
                <nav className={`menu ${isHamburgerOpen ? 'show' : ''}`} ref={hamburgerMenuRef}>
                <div className="menu-header">
                        <FontAwesomeIcon
                            className="account-section-icon close-button"
                            icon={faX}
                            onClick={closeMenu}
                        />
                    </div>
                    <Link className="navigation-link-drop" to="/products" onClick={closeMenu}>{t('header.allProducts')}</Link>
                    {/* <Link className="navigation-link-drop" to="/stock" onClick={closeMenu}>In stock</Link> */}
                    {user ? ( 
                        <Link className="navigation-link-drop" to="/account/update" onClick={closeMenu}>{t('header.account')}</Link>
                    ) : (
                        <Link className="navigation-link-drop" to="/account/login" onClick={closeMenu}>{t('header.logIn')}</Link>
                    )}
                
                    {showCurrencySelector && <Select
                        styles={{
                            control: (baseStyles) => ({
                                    ...baseStyles,
                                    marginTop: "10px",
                                    marginLeft: "10px",
                                    width: "125px",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    backgroundColor: "transparent",
                                    color: "var(--darker-purple)",
                                    borderWidth: "2px",
                                    borderColor: "var(--darker-purple)",
                                    boxShadow: "none",
                                    "&:hover": {
                                        borderColor: "var(--darker-purple)",
                                    },
                                }),
                                singleValue: (baseStyles) => ({
                                    ...baseStyles,
                                    color: "var(--darker-purple)", // Selected value color
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                }),
                                input: (baseStyles) => ({
                                    ...baseStyles,
                                    color: "transparent",
                                    color: "var(--darker-purple)",
                                }),
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    width: "125px",
                                    marginLeft: "10px",
                                    backgroundColor: "#e3e3e3"
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isSelected
                                    ? "#FFFFFF" // Background when selected
                                    : "transparent",
                                    color: "black", // Text color of items
                                    fontWeight: "bold",
                                    backgroundImage: state.options[state.options.length - 1] === state.data ? "none" : "linear-gradient(black, black)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "calc(100% - 25px) 1px",
                                    backgroundPosition: "12.5px bottom",
                                }),
                        }}
                        options={currencyOptions}
                        value={selectedCurrencyOption}
                        onChange={handleCurrencyChange}
                    />}
                    {process.env.REACT_APP_REGION === "CA" && (
                        <Select
                            id="language-select"
                            options={languageOptions}
                            value={selectedLanguageOption}
                            onChange={handleLanguageSelectChange}
                            isSearchable={false}
                            placeholder="English"
                            styles={{
                                control: (baseStyles) => ({
                                    ...baseStyles,
                                    marginTop: "10px",
                                    marginLeft: "10px",
                                    width: "125px",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    backgroundColor: "transparent",
                                    color: "var(--darker-purple)",
                                    borderWidth: "2px",
                                    borderColor: "var(--darker-purple)",
                                    boxShadow: "none",
                                    "&:hover": {
                                        borderColor: "var(--darker-purple)",
                                    },
                                }),
                                singleValue: (baseStyles) => ({
                                    ...baseStyles,
                                    color: "var(--darker-purple)", // Selected value color
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                }),
                                input: (baseStyles) => ({
                                    ...baseStyles,
                                    color: "transparent",
                                    color: "var(--darker-purple)",
                                }),
                                menu: (baseStyles) => ({
                                    ...baseStyles,
                                    width: "125px",
                                    marginLeft: "10px",
                                    backgroundColor: "#e3e3e3"
                                }),
                                option: (baseStyles, state) => ({
                                    ...baseStyles,
                                    backgroundColor: state.isSelected
                                    ? "#FFFFFF" // Background when selected
                                    : "transparent",
                                    color: "black", // Text color of items
                                    fontWeight: "bold",
                                    backgroundImage: state.options[state.options.length - 1] === state.data ? "none" : "linear-gradient(black, black)",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: "calc(100% - 25px) 1px",
                                    backgroundPosition: "12.5px bottom",
                                }),
                            }}
                        />
                    )}
                </nav>
            </div>
        </div>
    );
}

export default RightMenu;
